module.exports = __webpack_public_path__ + "static/media/done.5d7f0636.png";